import { AppButton } from "./AppButton";

/**
 * Shared unlock dialogs (safegeo-polaris/unlock.html).
 * Open only on click - never on page load (BFS 4.3.3).
 */
export function UnlockModals() {
  return (
    <>
      <s-modal id="unlock-starter" heading="Block countries you don’t sell to">
        <s-stack gap="base">
          <s-paragraph>
            Stop visitors from countries you don’t ship to. They see a polite
            “not available” page instead of your storefront.
          </s-paragraph>
          <s-unordered-list>
            <s-list-item>
              Pick countries to block; search bots still get through (SEO-safe)
            </s-list-item>
            <s-list-item>
              Customize the stop-page title and message
            </s-list-item>
            <s-list-item>
              You and your team still get in with the staff access link
            </s-list-item>
          </s-unordered-list>
          <s-box padding="base" background="subdued" borderRadius="base">
            <s-stack gap="small-100">
              <s-text>
                <s-text type="strong">Starter</s-text> · $9.99/month after a
                14-day free trial
              </s-text>
              <s-text color="subdued">
                Also includes: unlimited automatic redirects, sending
                visitors to another website
              </s-text>
            </s-stack>
          </s-box>
        </s-stack>
        <AppButton
          slot="primary-action"
          icon="key"
          to="/app/billing?plan=starter"
        >
          Upgrade now
        </AppButton>
        <AppButton
          slot="secondary-actions"
          commandFor="unlock-starter"
          command="--hide"
        >
          Not now
        </AppButton>
      </s-modal>

      <s-modal id="unlock-multi" heading="Connect your other Shopify stores">
        <s-stack gap="base">
          <s-paragraph>
            Send visitors from each country to the right one of your stores,
            managed from here.
          </s-paragraph>
          <s-unordered-list>
            <s-list-item>
              Connect up to 4 Shopify stores on one plan
            </s-list-item>
            <s-list-item>
              Your other stores don’t need their own plan
            </s-list-item>
            <s-list-item>Unlimited automatic redirects</s-list-item>
          </s-unordered-list>
          <s-box padding="base" background="subdued" borderRadius="base">
            <s-text>
              <s-text type="strong">Multi-store</s-text> · $29/month after a
              14-day free trial
            </s-text>
          </s-box>
        </s-stack>
        <AppButton slot="primary-action" icon="key" to="/app/billing?plan=multi">
          Upgrade now
        </AppButton>
        <AppButton
          slot="secondary-actions"
          commandFor="unlock-multi"
          command="--hide"
        >
          Not now
        </AppButton>
      </s-modal>
    </>
  );
}
